import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from 'components/UI/Modal/ModalPrimitive'
import { VariantForm, FormVariant } from './ProductModal/VariantForm'
import { notifyError } from 'services/toast'
import { useCreateVariant } from 'services/products_api'

interface StandaloneVariantModalProps {
  show: boolean
  onHide: () => void
}

export const StandaloneVariantModal: React.FC<StandaloneVariantModalProps> = ({
  show,
  onHide,
}) => {
  const createVariantMutation = useCreateVariant()

  const handleSave = async (variantData: FormVariant): Promise<void> => {
    try {
      await createVariantMutation.mutateAsync(variantData)
      // Close modal on success
      onHide()
    } catch (err) {
      console.error('Failed to create variant:', err)
      notifyError('Failed to create variant. Please try again.')
      throw err
    }
  }

  return (
    <Dialog open={show} onOpenChange={(open) => !open && onHide()}>
      <DialogContent id="variant-modal-content" size="lg" className="px-3">
        <DialogHeader>
          <DialogTitle>Create New Variant</DialogTitle>
        </DialogHeader>
        <div className="mt-4">
          <VariantForm
            onSave={handleSave}
            onCancel={onHide}
            initialData={null}
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}
